import { lazy } from '@/service/lazy'

export default [{
  name: 'Administração de Exceções',
  path: 'regrasbancos',
  id: 'regrasbancos',
  icon: 'fa fa-cog',
  component: lazy('app/default/gerenciador/regrasbancos/index'),
  meta: { requireAuth: true, rules: ['gerenciar_regra_comissionamento'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/regrasbancos.js